import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { SCHOOL_PORTAL_EVENT } from '@uniqcamp/shared';

/**
 * Shows API messages for school read-only (inactive) actions; staff-web uses ToastContext instead.
 */
export default function SchoolPortalApiListener() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const onForbidden = (e: Event) => {
      const ce = e as CustomEvent<{ message?: string }>;
      if (ce.detail?.message) {
        setMessage(ce.detail.message);
        setOpen(true);
      }
    };
    window.addEventListener(SCHOOL_PORTAL_EVENT.API_FORBIDDEN, onForbidden as EventListener);
    return () => window.removeEventListener(SCHOOL_PORTAL_EVENT.API_FORBIDDEN, onForbidden as EventListener);
  }, []);

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert onClose={() => setOpen(false)} severity="warning" variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
